import { useState } from "react";
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  TextField, 
  Button, 
  Typography 
} from "@mui/material";

import { observer } from "mobx-react";

function DialogNewFolder({ open, onComplete, onCancel }) {
  const [folderName, setFolderName] = useState("");

  const t = (val) => {return val;};
  const handleSubmit = (e) => {
    if (e) {
        e.preventDefault();
    }
    if (!folderName.trim()) {
        return;
    }
    
    onComplete(folderName.trim());
    setFolderName("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleCancel = () => {
    setFolderName("");
    onCancel();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleCancel}
      maxWidth="xs"
      fullWidth
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle sx={{ pb: 1 }}>
          <Typography variant="h6" component="span">{t("Create Folder")}</Typography>
        </DialogTitle>

        <DialogContent sx={{ pb: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
            {`${t("Enter folder name")}:`}
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label={t("Folder Name")}
            type="text"
            fullWidth
            variant="outlined"
            size="small"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCancel} color="inherit">
            {t("Cancel")}
          </Button>
          <Button 
            type="submit" 
            variant="contained" 
            disabled={!folderName.trim()}
          >
            {t("Create")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default observer(DialogNewFolder);